// src/constants/messages.ts
export const messageConfig = {
  requestSong: {
    message:
      'Can’t find the song you’re looking for? Send us a request—we’ve got you covered!',
    message1: 'Can’t find the song you’re looking for?',
    message2: 'Send us a request—we’ve got you covered!',
    buttonText: 'Request Song',
  },
  receivedSong: {
    message:
      'Song Request received! Our team will review it to ensure it meets our guidelines. If approved, you’ll hear it soon!',
  },
  uploadSong: {
    selectFile: 'Please select a file',
    selectLibrary: 'Please select a library',
    selectStation: 'Please select a station',
    uploadSuccess: 'Song uploaded successfully!',
    uploadFailed: 'Failed to upload song',
  },
  radioSongReset: {
    success:
      'All selected songs have been cleared successfully. Add new songs to ensure they are considered for playlist generation and available in the player',
    errorSongs: 'Failed to reset songs. Please try again.',
    errorGenres: 'Failed to reset genres. Please try again.',
  },
  noSongsAvailable: 'No Songs Available',
  participationForm: {
    seasonalDateRange: {
      addIndividualDates: 'Add Individual Dates',
      addSeasonalDateRanges: 'Add Seasonal Date Ranges',
      descriptionOneDay: 'Select individual dates for your seasonal operation.',
      descriptionMultipleDays:
        'Select start and end dates for your seasonal operation periods.',
    },
  },
};
